<template>
  <v-form v-if="editable">
    <v-container fluid class="px-2 py-2">
      <v-btn class="nav-btn" icon color="#f3f3f3" small @click="$router.back()">
        <v-icon>close</v-icon>
      </v-btn>
      <div class="survey-form">
        <v-text-field v-model="survey.name" :counter="50" label="问卷名称" hide-details required :error="titleError">
        </v-text-field>
        <v-textarea v-model="survey.desc" :counter="500" hide-details label="问卷填写说明"></v-textarea>
        <v-menu ref="datePicker" v-model="datePicker" :close-on-content-click="false" :nudge-right="40" lazy
          transition="scale-transition" offset-y full-width min-width="120px" hide-details>
          <template v-slot:activator="{ on }">
            <v-text-field v-model="survey.durTime" flat readonly label="截止日期（如果不确定可以不填写，需要的时候可以关闭调查）" v-on="on">
            </v-text-field>
          </template>
          <v-date-picker v-model="survey.durTime" no-title scrollable locale="zh-cn" @change="datePicker = false">
          </v-date-picker>
        </v-menu>
        <v-checkbox v-model="survey.reqSign" hide-details label="需要填写人签字"></v-checkbox>
      </div>
      <div class="survey-item-edit">
        <label>问卷题目</label>
        <div class="survey-items">
          <div class="survey-item" :class="{ editable: i.edit }" v-for="(i, idx) in items" :key="i.id || i.k">
            <template v-if="i.edit">
              <div class="float-btns">
                <v-icon small @click="onDelete(idx)">delete</v-icon>
                <v-icon small @click="onEditDone(idx)">done</v-icon>
              </div>
              <v-text-field v-model="i.title" :counter="300" :label="idx + 1 + '.题干'" hide-details required
                :error="i.error || false"></v-text-field>
              <v-checkbox v-model="i.multiSel" hide-details label="可以多选"></v-checkbox>
              <ul>
                <li v-for="(opt, oidx) in i.opts" :key="opt.k">
                  <v-text-field v-model="opt.val" :counter="300" :label="'选项' + (oidx + 1)" hide-details required
                    append-outer-icon="delete" @click:append-outer="onDelOpt(idx, oidx)" :error="opt.error || false">
                  </v-text-field>
                </li>
                <li>
                  <v-btn small depressed color="primary" @click="onAddItem(idx)">
                    <v-icon>add</v-icon>添加选项
                  </v-btn>
                </li>
              </ul>
            </template>
            <template v-else>
              <div class="float-btns">
                <v-icon small @click="onDelete(idx)">delete</v-icon>
                <v-icon small @click="onEditStart(idx)">edit</v-icon>
              </div>
              <p>
                <span class="seq">{{ idx + 1 }}.</span>
                <v-chip v-if="i.multiSel" small>多选</v-chip>
                {{ i.title }}
              </p>
              <ul>
                <li v-for="opt in i.opts" :key="opt.k">
                  {{ opt.val }}
                </li>
              </ul>
            </template>
          </div>
        </div>
        <div class="actions">
          <v-btn color="primary" depressed small @click="onAdd">
            <v-icon>add</v-icon>添加题目
          </v-btn>
        </div>
      </div>
      <div class="form-actions">
        <v-btn depressed color="primary" @click="onSave()">保存</v-btn>
        <v-btn depressed @click="onSave(true)">保存并发布</v-btn>
      </div>
    </v-container>
  </v-form>
</template>
<script>
export default {
  name: "survey-editor",
  data() {
    return {
      datePicker: false,
      survey: {},
      items: [],
      delIds: [],
      titleError: false,
      editable: true,
    };
  },
  methods: {
    init() {
      let self = this,
        id = self.$route.params._sid;
      self.delIds = [];
      if (id && id != "0") {
        self.$axios.get(`/home/admin/c/survey/get/${id}`).then((r) => {
          self.survey = r.data.message;
          let items = r.data.items,
            tmp = [];
          if (items && items.length > 0) {
            for (let i in items) {
              let item = items[i],
                itemd = {
                  id: item.id,
                  title: item.title,
                  multiSel: item.multiSel,
                  error: false,
                },
                opts = (itemd.opts = []);
              for (let j = 1; j < 7; j++) {
                if (!item["opt" + j]) {
                  break;
                }
                opts.push({ k: j, val: item["opt" + j], error: false });
              }
              tmp.push(itemd);
            }
          }
          self.items = tmp;
        });
        return;
      }
    },
    onEditDone(idx) {
      let self = this,
        item = self.items[idx];
      //做一次验证
      if (!self.validateItem(item)) {
        item.edit = false;
      }
      self.$set(self.items, idx, item);
    },
    onEditStart(idx) {
      let self = this,
        items = self.items,
        item = items[idx];
      for (let i in items) {
        let tmp = items[i];
        if (tmp.edit) {
          if (self.validateItem(tmp)) {
            self.$set(items, i, tmp);
            return;
          }
          tmp.edit = false;
          self.$set(items, i, tmp);
          break;
        }
      }
      item.edit = true;
      self.$set(items, idx, item);
    },
    onAdd() {
      let self = this,
        items = self.items;
      for (let i in items) {
        let tmp = items[i];
        if (tmp.edit) {
          tmp.edit = false;
          self.$set(items, i, tmp);
          break;
        }
      }
      items.push({
        k: Date.now(),
        edit: true,
        opts: [{ k: Date.now(), val: "", error: false }],
      });
    },
    onDelete(idx) {
      let self = this,
        items = self.items,
        item = items[idx];
      if (item.id) {
        self.delIds.push(item.id);
      }
      items.splice(idx, 1);
    },
    onAddItem(idx) {
      let self = this,
        items = self.items,
        item = items[idx];
      item.opts.push({ k: Date.now(), val: "", error: false });
      self.$set(items, idx, item);
    },
    onDelOpt(idx, oidx) {
      let self = this,
        items = self.items,
        item = items[idx],
        opts = item.opts;
      opts.splice(oidx, 1);
      self.$set(items, idx, item);
    },
    validateItem(item) {
      let error = (item.error = !item.title),
        opts = item.opts;
      for (let o of opts) {
        let e = !o.val;
        o.error = e;
        error = error || e;
      }
      return error;
    },
    onSave(pub) {
      let self = this,
        s = self.survey,
        items = self.items;
      //验证一下survey
      if (!s.name) {
        self.titleError = true;
        return;
      }
      if (items.length == 0) {
        self.$status("必须填写问卷题目才能提交~", "error");
        return;
      }
      //遍历一下问卷题目，看有没有error的
      for (let i of items) {
        if (i.error) {
          self.$status("正确填写问卷题目才能提交~", "error");
          return;
        }
        let opts = i.opts;
        if (opts.length == 0) {
          self.$status("正确填写问卷题目选项才能提交~", "error");
          return;
        }
        for (let opt of opts) {
          if (opt.error) {
            self.$status("正确填写问卷题目选项才能提交~", "error");
            return;
          }
        }
      }

      //构建表单进行提交
      let d = { ...s, closed: !pub };
      d.reqSign = d.reqSign || false;
      for (let idx in items) {
        let item = items[idx],
          itemd = {
            title: item.title,
            opts: [],
            mSel: item.multiSel || false,
          };
        for (let oidx in item.opts) {
          itemd.opts.push(item.opts[oidx].val);
        }
        if (item.id) {
          itemd["id"] = item.id;
        }
        d["item_" + idx] = JSON.stringify(itemd);
      }

      if (self.delIds && self.delIds.length > 0) {
        d.delIds = self.delIds.join("_");
      }
      self.$axios
        .post(
          `/home/admin/c/survey/${s.id ? "update/" + s.id : "create"}`,
          self.$qs.stringify(d)
        )
        .then((r) => {
          if (r.data.status == "ok") {
            self.$status("保存成功～", "success");
            self.$router.back();
          } else {
            self.$status(r.data.message || "保存失败～", "error");
          }
        });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.survey-form,
.survey-item-edit {
  padding: 16px;
  margin: 8px 0;
  border-radius: 4px;
}

.survey-item-edit {
  background-color: #f8f8f8;
  border: 1px solid #f6f6f6;
}

.survey-items {
  width: 100%;
}

.survey-item {
  background-color: white;
  padding: 16px;
  margin: 8px 0;
  border-radius: 4px;
}

.survey-item p {
  margin: 0;
  padding: 0;
}

.survey-item ul {
  margin-top: 8px;
  line-height: 24px;
}

.float-btns {
  text-align: right;
}

.float-btns .v-icon {
  margin: 0 2px;
  cursor: pointer;
  float: right;
}

.form-actions .v-btn {
  margin: 8px;
}

.nav-btn {
  float: right;
}
</style>
